///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const Arrow = ({
  height,
  fill = "#343434",
  title = messages.arrow.defaultMessage,
  width,
  rotateDegree = 0,
  ...props
}) => (
  <svg
    aria-labelledby="arrow-icon"
    height={height}
    viewBox="0 0 10 10"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${rotateDegree}deg)` }}
    {...props}
  >
    <title id="arrow-icon">{title}</title>
    <path
      fill={fill}
      d="M9.667 5l-.823-.822-3.26 3.254V.333H4.416v7.1L1.162 4.171.333 5 5 9.667z"
    />
  </svg>
);

export default Arrow;
